import React, { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { TPlatformConfiguration } from "../../shared/types/platformConfiguration";
import { Box, CircularProgress } from "@mui/material";

// Lazy load the heavy components
const MyEquimetres = lazy(() => import("./MyEquimetres"));
const MyEqmFleet = lazy(() => import("./MyEqmFleet"));

const FLEET_CONFIG_KEY = 'FLEET_PAGE';

function EqmRedirection() {
  const config = useSelector<RootState, TPlatformConfiguration[] | undefined>(
    (state) => state.user.platformConfigurations,
  );

  const fleetConfig = config?.find((c) => c.key === FLEET_CONFIG_KEY);

  return (
    <Suspense
      fallback={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="200px"
          width="100%"
        >
          <CircularProgress size={32} />
        </Box>
      }
    >
      {fleetConfig && fleetConfig.value === 'true' ? (
        <MyEqmFleet />
      ) : (
        <MyEquimetres />
      )}
    </Suspense>
  );
}

export default EqmRedirection;